import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import SearchBar from 'material-ui-search-bar';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { FormControlLabel, Typography, Switch } from '@material-ui/core';
import ListMobile from './list-mobile';
import {
  getLicenseTypeLabelShort, getCompletedControlLabel, getLocationName,
} from '../utils';

const LicenseListMobile = ({
  licenses, showZone, history, workPlan, workPlanList, showIsControlCompleted, translate,
}) => {
  const [rows, setRows] = useState(licenses);
  const [hideCompleted, setHideCompleted] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => setRows(licenses), [licenses]);
  useEffect(updateRowsToDisplay, [searchQuery]);
  useEffect(updateRowsToDisplay, [hideCompleted]);

  function updateRowsToDisplay() {
    let licensesToDisplay = licenses;

    if (showIsControlCompleted && hideCompleted) {
      licensesToDisplay = licensesToDisplay.filter((license) => {
        const completedControl = getCompletedControlLabel(
          showIsControlCompleted,
          workPlan,
          workPlanList,
          license.sysId,
        );
        return !completedControl.startsWith('Ja');
      });
    }

    if (searchQuery !== '') {
      const searchedValLowerCase = searchQuery.toLowerCase();

      licensesToDisplay = licensesToDisplay.filter((license) => {
        const location = getLocationName(license).toLowerCase();
        const licensee = license.licensee.name.toLowerCase();
        return location.includes(searchedValLowerCase) || licensee.includes(searchedValLowerCase);
      });
    }

    setRows(licensesToDisplay);
  }

  return (
    <>
      {showIsControlCompleted && (
        <FormControlLabel
          control={(
            <Switch
              checked={hideCompleted}
              onChange={(e) => {
                setHideCompleted(e.target.checked);
              }}
              name="hideCompleted"
              color="primary"
            />
          )}
          label="Vis kun bevillinger uten utført kontroll"
        />
      )}
      <SearchBar
        value={searchQuery}
        placeholder="Søk etter sted eller bevillingshaver"
        onChange={searchVal => setSearchQuery(searchVal)}
        onCancelSearch={() => setSearchQuery('')}
        style={{ margin: '1rem 0' }}
      />
      <ListMobile
        fetched
        rowsPerPage={5}
        content={rows && rows.map((license) => {
          const completedControl = getCompletedControlLabel(
            showIsControlCompleted,
            workPlan,
            workPlanList,
            license.sysId,
          );

          return ({
            sysId: license.sysId,
            primary: getLocationName(license),
            secondary: (
              <>
                <Typography component="span" variant="body1" display="block">
                  {`Bevillingstype: ${getLicenseTypeLabelShort(license.licenseType)}`}
                </Typography>
                <Typography component="span" variant="body1" display="block">
                  {`Bevillingshaver: ${license.licensee.name}`}
                </Typography>
                {showZone && (
                  <Typography component="span" variant="body1" display="block">
                    {`Kontrollsone: ${(license.controlZone && license.controlZone.indexOf('sone') === 0)
                      ? license.controlZone.substring(4) : license.controlZone}`}
                  </Typography>
                )}
                {showIsControlCompleted && (
                  <Typography component="span" variant="body1" display="block">
                    {`${translate('license.completedControl')}: ${completedControl}`}
                  </Typography>
                )}
              </>
            ),
            onClick: () => history.push(`/${license.sysId}`),
          });
        })}
      />
    </>
  );
};


LicenseListMobile.defaultProps = {
  showZone: true,
  workPlan: null,
  workPlanList: [],
};

LicenseListMobile.propTypes = {
  licenses: PropTypes.array.isRequired,
  showZone: PropTypes.bool,
  history: PropTypes.object.isRequired,
  workPlan: PropTypes.object,
  workPlanList: PropTypes.array,
  showIsControlCompleted: PropTypes.bool.isRequired,
  translate: PropTypes.any.isRequired,
};

const mapStateToProps = ({ localize }) => ({
  translate: getTranslate(localize),
});

export default connect(mapStateToProps)(withRouter((LicenseListMobile)));
